
































import {
  Component,
  Prop,
  Vue,
  Mixins,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { specialChannel } from "@root/lib/mixins";
import gtMedia from "@/components/pages/ProductCreate/media.vue";
import channelCategory from "@/components/pages/ProductCreate/channelCategory.vue";
import channelSkuBLock from "@/components/pages/ProductCreate/channelComponents/channelSkuBLock.vue";
const productCreate = namespace("productCreate");
@Component({
  components: {
    gtMedia,

    channelCategory,
    channelSkuBLock
  }
})
export default class channelSkuTab extends Mixins(specialChannel) {
  @productCreate.Action queryConnAttrList;
  @productCreate.Action querySkuChannelPage;
  // @productCreate.Action getConnExtendParams;
  @productCreate.Getter propertiesData;
  @productCreate.Getter skuList: any[];
  @InjectReactive("curChannel") curChannel;
  @InjectReactive("curCategory") curCategory;
  @InjectReactive("curBrandId") curBrandId;
  @Prop({ default: false }) isEdit;
  @Prop({ default: false }) readonly; // 是否只读
  private vaildates = [];
  baseConnAttrList = [];
  connAttrList = [];
  editorList = [];
  blockList = [];
  skuData = {};
  channelSkuList = [];
  imagesList = [];
  loading = false;
  get isSpuSaved() {
    return !this.curChannel.isEdit;
  }

  async created() {
    if (!this.curCategory || this.curCategory.length === 0) {
      return;
    }

    this.loading = true;
    await this.getChannelSku();
    let param: any = {
      channelCode: this.curChannel.channelCode,
      shopCode: this.curChannel.value,
      categoryId: this.curCategory[this.curCategory.length - 1]
      // shopCode: "10000151",
      // categoryId: "16449"
    };
    if (this.curBrandId && this.isTmall(this.curChannel.channelCode)) {
      param.brandId = this.curBrandId;
    }
    let skuAttrList = await this.queryConnAttrList({
      input: {
        ...param,
        attrType: 2
      }
    });
    let { baseConnAttrList = [], connAttrList = [] } = skuAttrList;
    if (baseConnAttrList) {
      let index = baseConnAttrList.findIndex(
        _ => _.attrCode === "categoryCode"
      );

      if (index > -1) {
        baseConnAttrList.splice(index, 1);
      }
      this.imagesList = baseConnAttrList.filter(_ => _.attrCode === "images");
    }
    this.blockList = [...baseConnAttrList, ...connAttrList];

    this.loading = false;
  }
  async getChannelSku() {
    let { map = {}, list = [], total } = await this.querySkuChannelPage({
      input: {
        productCode: this.propertiesData.productCode,
        shopCode: this.curChannel.value
      },
      pageInfo: {
        pageNum: 1,
        pageSize: 1000
      }
    });

    // this.skuList.forEach(async (_, index) => {
    //   let res = await this.getConnExtendParams({
    //     queryVo: {
    //       relationCode: _.skuCode,
    //       attrType: 2,
    //       shopCode: this.curChannel.value
    //     }
    //   });
    //   console.log(res, 5566);
    // });
    this.channelSkuList = list;
    this.skuData = map;
  }
  vaildateRegister(fn) {
    this.vaildates.push(fn);
  }
  vaildateRemove(fn) {
    let index = this.vaildates.findIndex(item => item === fn);

    if (index > -1) {
      this.vaildates.splice(index, 1);
    }
  }
  submit() {
    return Promise.all(this.vaildates.map(vaildate => vaildate()));
  }
  switchCategory(data) {
    this.$emit("switchCategory", data);
  }
  saveSkuSuccess() {
    this.$emit("saveSkuSuccess");
  }
}
